import styled from 'styled-components';
import { primary, neutral } from '../../../../style/colors';

const fadeIn = `
  @keyframes fadeIn {
    from { opacity: 0; transform: translateY(10px); }
    to { opacity: 1; transform: translateY(0); }
  }
`;

const slideIn = `
  @keyframes slideIn {
    from { opacity: 0; transform: translateX(-10px); }
    to { opacity: 1; transform: translateX(0); }
  }
`;

export const Section = styled.div`
  padding: 0;
`;

export const SectionTitle = styled.h2`
  font-size: 22px;
  font-weight: 700;
  color: ${neutral[900]};
  margin-bottom: 24px;
  letter-spacing: -0.3px;
`;

export const MarketingText = styled.div`
  ${fadeIn}
  font-size: 15px;
  line-height: 1.8;
  color: ${neutral[600]};
  margin-bottom: 24px;
  animation: fadeIn 0.4s ease;
`;

export const BenefitsGrid = styled.div`
  display: grid;
  grid-template-columns: ${props => props.singleColumn ? '1fr' : 'repeat(2, 1fr)'};
  gap: 40px;
  margin-top: 24px;
  max-width: ${props => props.singleColumn ? '600px' : 'none'};

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 32px;
  }
`;

export const BenefitsColumn = styled.div``;

export const BenefitsList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const BenefitItem = styled.li`
  ${slideIn}
  font-size: 15px;
  line-height: 1.7;
  color: ${neutral[600]};
  padding-left: 32px;
  position: relative;
  animation: slideIn 0.3s ease backwards;
  animation-delay: ${props => props.index * 0.05}s;

  i {
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    color: ${primary[500]};
    font-size: 20px;
  }
`;

export const SubTitle = styled.h3`
  font-size: 17px;
  font-weight: 600;
  color: ${neutral[700]};
  margin-bottom: 16px;
  letter-spacing: -0.2px;
`;
